/**
 * Quick Add to Cart Functionality
 * Handles adding products to cart from product cards without page reload
 */

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    if (this.submitButton.classList.contains('loading')) return;

    this.handleErrorMessage();
    this.submitButton.classList.add('loading');
    this.submitButton.setAttribute('aria-disabled', true);

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      }
    };

    const formData = new FormData(this.form);
    config.body = formData;

    fetch(`${window.Shopify.routes.root}cart/add.js`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        // Success - update cart
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');

        // Add success state
        const originalText = this.submitButton.querySelector('span').textContent;
        this.submitButton.querySelector('span').textContent = '✓ Added!';
        this.submitButton.classList.add('success');

        // Reset button after 2 seconds
        setTimeout(() => {
          this.submitButton.querySelector('span').textContent = originalText;
          this.submitButton.classList.remove('success');
        }, 2000);

        // Trigger cart update event for cart drawer/header
        this.updateCartCount();
        this.dispatchCartUpdateEvent();
      })
      .catch((e) => {
        console.error(e);
        this.handleErrorMessage('An error occurred. Please try again.');
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

    if (!this.errorMessageWrapper) return;

    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  updateCartCount() {
    // Update cart count in header if it exists
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
        cartCountElements.forEach((element) => {
          element.textContent = cart.item_count;

          // Animate the cart count
          element.classList.add('cart-count-bounce');
          setTimeout(() => {
            element.classList.remove('cart-count-bounce');
          }, 500);
        });
      })
      .catch((e) => {
        console.error('Error updating cart count:', e);
      });
  }

  dispatchCartUpdateEvent() {
    // Dispatch custom event for other components to listen to
    const event = new CustomEvent('cart:updated', {
      bubbles: true,
      detail: {
        source: 'quick-add'
      }
    });
    document.dispatchEvent(event);
  }
}

customElements.define('product-form', ProductForm);

// Add success state styling
const style = document.createElement('style');
style.textContent = `
  .button--quick-add.success {
    background: linear-gradient(135deg, #4CAF50, #45a049) !important;
  }

  .cart-count-bounce {
    animation: cartCountBounce 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  @keyframes cartCountBounce {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }
`;
document.head.appendChild(style);

// Error message styling
const errorStyle = document.createElement('style');
errorStyle.textContent = `
  .product-form__error-message-wrapper {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #ff5300;
    color: white;
    padding: 12px 24px;
    border-radius: 25px;
    box-shadow: 0 4px 12px rgba(255, 83, 0, 0.4);
    z-index: 9999;
    font-weight: 600;
    animation: slideUp 0.3s ease-out;
  }

  .product-form__error-message-wrapper[hidden] {
    display: none;
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`;
document.head.appendChild(errorStyle);
